import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router';
import { CarFormView } from './car-form-view';
import {
	getLegalsSelector,
	getIsLegalsLoadingSelector,
	getCarTypesSelector,
	getIsAdminSelector,
	getIsAvailableTrailersSelector,
	getIsCarInfoLoadingSelector,
	getIsCarTypesLoadingSelector,
	getIsModesLoadingSelector,
	getIsOwnershipsLoadingSelector,
	getIsOwnershipVisibleSelector,
	getIsTrailersListLoadingSelector,
	getIsTrailerVisibleSelector,
	getIsTypeDateIssueVisibleSelector,
	getModesSelector,
	getOwnershipsSelector,
	getTrailersListSelector,
} from '../../selectors';

const CarFormWrapper = ({
	trailersList,
	isTrailersListLoading,
	isCarInfoLoading,
	ownerships,
	isOwnershipsLoading,
	legals,
	isLegalsLoading,
	carTypes,
	isTypeDateIssueVisible,
	isTrailerVisible,
	isOwnershipVisible,
	modes,
	isAdmin,
	isCarTypesLoading,
	isModesLoading,
	isAvailableTrailers,
}) => {
	const history = useHistory();

	const { search, pathname } = useLocation();

	const handleAddTrailerButtonClick = () => {
		const currentQuery = new URLSearchParams(search);

		const mode = currentQuery.get('mode');

		const id = currentQuery.get('id');

		// Save current car form state in query
		const newQuery = new URLSearchParams();
		newQuery.set('modal', 'trailer');
		newQuery.set('mode', 'add');
		newQuery.set('returnTo', 'car');
		if (mode) newQuery.set('returnMode', mode);
		if (id) newQuery.set('returnId', id);

		history.push(`${pathname}?${newQuery.toString()}`);
	};

	return (
		<CarFormView
			trailersList={trailersList}
			isTrailersListLoading={isTrailersListLoading}
			onAddTrailerButtonClick={handleAddTrailerButtonClick}
			isCarInfoLoading={isCarInfoLoading}
			ownerships={ownerships}
			isOwnershipsLoading={isOwnershipsLoading}
			legals={legals}
			isLegalsLoading={isLegalsLoading}
			carTypes={carTypes}
			isTypeDateIssueVisible={isTypeDateIssueVisible}
			isTrailerVisible={isTrailerVisible}
			isOwnershipVisible={isOwnershipVisible}
			modes={modes}
			isAdmin={isAdmin}
			isCarTypesLoading={isCarTypesLoading}
			isModesLoading={isModesLoading}
			isAvailableTrailers={isAvailableTrailers}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isCarInfoLoading: getIsCarInfoLoadingSelector(),
	trailersList: getTrailersListSelector(),
	isTrailersListLoading: getIsTrailersListLoadingSelector(),
	ownerships: getOwnershipsSelector(),
	isOwnershipsLoading: getIsOwnershipsLoadingSelector(),
	legals: getLegalsSelector(),
	isLegalsLoading: getIsLegalsLoadingSelector(),
	carTypes: getCarTypesSelector(),
	isTypeDateIssueVisible: getIsTypeDateIssueVisibleSelector(),
	isTrailerVisible: getIsTrailerVisibleSelector(),
	isOwnershipVisible: getIsOwnershipVisibleSelector(),
	modes: getModesSelector(),
	isAdmin: getIsAdminSelector(),
	isCarTypesLoading: getIsCarTypesLoadingSelector(),
	isModesLoading: getIsModesLoadingSelector(),
	isAvailableTrailers: getIsAvailableTrailersSelector(),
});

CarFormWrapper.propTypes = {
	trailersList: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			key: PropTypes.string.isRequired,
		}),
	),
	isTrailersListLoading: PropTypes.bool.isRequired,
	isCarInfoLoading: PropTypes.bool.isRequired,
	isOwnershipsLoading: PropTypes.bool,
	ownerships: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	legals: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isLegalsLoading: PropTypes.bool.isRequired,
	carTypes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isTypeDateIssueVisible: PropTypes.bool.isRequired,
	isTrailerVisible: PropTypes.bool.isRequired,
	isOwnershipVisible: PropTypes.bool,
	modes: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAdmin: PropTypes.bool.isRequired,
	isCarTypesLoading: PropTypes.bool.isRequired,
	isModesLoading: PropTypes.bool.isRequired,
	isAvailableTrailers: PropTypes.bool.isRequired,
};

const CarForm = connect(mapStateToProps)(CarFormWrapper);

export { CarForm };
